import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "crm:flex crm:w-full"
}
const _hoisted_2 = { class: "crm:mt-2! crm:mb-4! crm:flex!" }
const _hoisted_3 = { class: "crm:mr-4" }
const _hoisted_4 = {
  key: 0,
  class: "crm:font-bold"
}
const _hoisted_5 = { class: "crm:flex" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "crm:mt-1 crm:flex crm:bg-info--bg crm:rounded-md crm:py-1 crm:px-2" }
const _hoisted_8 = { class: "crm:mt-4" }
const _hoisted_9 = { class: "crm:my-4" }
const _hoisted_10 = { class: "crm:flex crm:justify-end" }

import AppChecklistMatrice from "../checklist-matrice/AppChecklistMatrice.vue";
import {inject, reactive, onMounted} from "vue";
import {edit, alert_information_circle} from '../../svg/svgs.js'
import {useChecklist} from "../../composable/useChecklist";
import {useChecklistStore, usePraticaStore} from "../../store/crm.store";
import {useDefineModal} from "../../composable/definer/useDefineModal";


export default {
  __name: 'AppChecklistModello',
  props: {
  /**
   * Dati del modello
   */
  modelloChecklist: {
    type: [Object, Array],
    default() {
      return null
    }
  },
  /**
   * ID del soggetto di riferimento
   */
  soggettoId: {
    type: [String, Number],
    default: null
  },
},
  emits: [
  /**
   * Emit per callback dopo una creazione di un modello
   */
  'save:model',
  /**
   * Emit per callback dopo aggiornamento di un modello
   */
  'update:model'
],
  setup(__props, { emit: __emit }) {

/**
 * @doc
 * Gestisce la creazione/aggiornamento di un modello di checklist
 */
const props = __props

const emits = __emit

const checklistStore = useChecklistStore();
const praticaStore = usePraticaStore();
const $AxiosClient = inject('$AxiosClient');

const checklistModello = reactive({
  // utilizzato per renderizzare il componente solo dopo averlo inizializzato al mounted
  isReady: false,
  // se true mostra il form di modifica titolo del modello checklist
  isEditChecklistTitle: false,
  // se popolato possiede il json e le proprietà del modello
  modello: props.modelloChecklist,
  // in fase di creazione modello memorizza il titolo inserito
  titoloModello: {value: props.modelloChecklist ? props.modelloChecklist.title : '', required: true},
  // proprietà usate in caso di aggiornamento del modello esistente
  richiesteDocumentiDefault: null,
  forceAccordionActived: null
});

const use_checklist = useChecklist();

/**
 * setta in modalità modifica il titolo del modello della checklist
 * @return {boolean}
 */
const editChecklistTitle = () => checklistModello.isEditChecklistTitle = true;

/**
 * Aggiorna il titolo del modello checklist e reinvia al backend tutto il json del modello checklist
 */
function updateModelloChecklistTitle(richiesteDocumenti, notaChecklist) {
  checklistModello.isEditChecklistTitle = false;
  saveChecklistModel(richiesteDocumenti, notaChecklist,true, checklistModello.modello.modello_id);
}

/**
 * Aggiorna i dati del modello checklist
 * @param richiesteDocumenti
 * @param notaChecklist
 * @param is_submit
 * @param modello_id
 * @return {Promise<void>}
 */
async function updateModelloChecklist(richiesteDocumenti, notaChecklist, is_submit = false, modello_id = null) {
  await saveChecklistModel(richiesteDocumenti, notaChecklist, is_submit, modello_id);
}

/**
 * Salva o aggiorna modello della checklist
 * @param richiesteDocumenti
 * @param notaChecklist
 * @param is_submit
 * @param modello_id
 * @return {Promise<void>}
 */
async function saveChecklistModel(richiesteDocumenti, notaChecklist, is_submit = false, modello_id = null) {
  if(!is_submit) modaleTitoloModello.open();

  if(is_submit) {
    let params = modello_id ? {modello_id: modello_id.$oid} : {id: checklistStore.checkList.id};
    params = {...params, ...use_checklist.generateChecklistToSave(props.soggettoId, richiesteDocumenti, notaChecklist )}
    await $AxiosClient.post('Questionari', modello_id ? 'updateModello' : 'createModello', {title: checklistModello.titoloModello.value, ...params});
  }

  // se sono in fase di creazione modello emitto dopo la sua effettiva creazione
  if(!modello_id && is_submit) emits('save:model')

  // se sono in fase di aggiornamento del modello emitto dopo il suo effettivo aggiornamento
  if(modello_id && is_submit) emits('update:model')
}

/**
 * Imposta il modello di checklist selezionato
 * @param modello
 */
async function cambiaModello(modello) {
  checklistModello.richiesteDocumentiDefault = {};
  checklistModello.forceAccordionActived = {};
  (praticaStore.tipoUtenteConnesso === 'notaio') ? await checklistStore.getChecklist(modello) : ''

  if(modello) {
    let documentiCustom = [];
    // ciclo tutti gli elementi del modello e gli aggiungo alla lista di documenti richiesti
    Object.keys(modello.elements.atom_components.elements).forEach((elementKey) => {
      let elementRichiesta = modello.elements.atom_components.elements[elementKey];
      // cancello eventuali id|hash perchè dovranno essere nuovamente creati in fase di invio checklist
      delete elementRichiesta['hash'];
      delete elementRichiesta['id'];
      // setto l'accordion active per far si che si apra mostrando le richieste di documenti aggiunte
      if(!checklistModello.forceAccordionActived[elementRichiesta['category_ref']]) checklistModello.forceAccordionActived[elementRichiesta['category_ref']] = true;
      checklistModello.richiesteDocumentiDefault[modello.elements.atom_components.elements[elementKey].keyMap] = elementRichiesta
      if(modello.elements.atom_components.elements[elementKey].custom) documentiCustom.push(modello.elements.atom_components.elements[elementKey])
    })

    // se trovo richieste di documenti personalizzati li aggiungo al json del modello di default
    if(documentiCustom.length > 0) {
      documentiCustom.forEach((document) => {
        let docKeyMapPath = document.keyMap.split('|');
        checklistStore.checkList.checklist[docKeyMapPath[0]].categories[docKeyMapPath[1]].documents.push(document)
      })
    }
  }
}

onMounted(async() => {
  if(props.modelloChecklist) await cambiaModello(props.modelloChecklist);
  checklistModello.isReady = true;
})

const $DesignSystem = inject('$DesignSystem')

const modaleTitoloModello = useDefineModal('modalCreateChecklistModel', 'Nome del modello')

return (_ctx, _cache) => {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_input_text = _resolveComponent("base-input-text")
  const _component_base_button = _resolveComponent("base-button")
  const _component_base_form = _resolveComponent("base-form")
  const _component_base_textarea_floating_label = _resolveComponent("base-textarea-floating-label")
  const _component_base_input_text_floating_label = _resolveComponent("base-input-text-floating-label")
  const _component_base_modal = _resolveComponent("base-modal")

  return (checklistModello.isReady)
    ? (_openBlock(), _createBlock(AppChecklistMatrice, {
        key: 0,
        "soggetto-id": __props.soggettoId,
        "richieste-documenti-default": checklistModello.richiesteDocumentiDefault,
        "force-accordion-actived": checklistModello.forceAccordionActived,
        "nota-checklist-default": checklistModello.modello ? checklistModello.modello.elements.atom_components.note : ''
      }, {
        "matrice-title": _withCtx(({richiesteDocumenti, notaChecklist}) => [
          (checklistModello.modello)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("h5", _hoisted_2, [
                  _createElementVNode("span", _hoisted_3, [
                    _cache[4] || (_cache[4] = _createElementVNode("span", { class: "crm:inline-block crm:w-[150px]" }, "Nome modello:", -1 /* CACHED */)),
                    (!checklistModello.isEditChecklistTitle)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(checklistModello.titoloModello.value), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ]),
                  (!checklistModello.isEditChecklistTitle)
                    ? (_openBlock(), _createBlock(_component_base_icon, {
                        key: 0,
                        icon: _unref(edit),
                        class: "crm:ml-2 crm:cursor-pointer",
                        onClick: _withModifiers(editChecklistTitle, ["prevent"]),
                        sizing: {width: '15px', height: '15px'}
                      }, null, 8 /* PROPS */, ["icon"]))
                    : _createCommentVNode("v-if", true)
                ]),
                (checklistModello.isEditChecklistTitle)
                  ? (_openBlock(), _createBlock(_component_base_form, {
                      key: 0,
                      "custom-classes": {root: {base: {value: 'crm:w-full'}}},
                      name: "changeChecklistModelTitle",
                      "post-params": {url: 'Pratica', action: 'process'},
                      data: checklistModello.titoloModello,
                      actionsSetting: {'confirm': {show: false}, 'continue': {show: false}, 'reset': {show: false}}
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_component_base_input_text, {
                            "custom-classes": {container: {base: {value: 'crm:w-[80%]'}}},
                            name: "cambiotitolomodellochecklist",
                            validateTo: checklistModello.titoloModello,
                            "onUpdate:validateTo": _cache[0] || (_cache[0] = $event => ((checklistModello.titoloModello) = $event))
                          }, null, 8 /* PROPS */, ["validateTo"]),
                          _createVNode(_component_base_button, {
                            class: "crm:ml-2!",
                            mode: "confirm",
                            "onClick:cta": $event => (updateModelloChecklistTitle(richiesteDocumenti, notaChecklist))
                          }, {
                            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                              _createTextVNode(" Conferma ", -1 /* CACHED */)
                            ]))]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["onClick:cta"]),
                          _createVNode(_component_base_button, {
                            class: "crm:ml-2!",
                            "onClick:cta": _cache[1] || (_cache[1] = $event => (checklistModello.isEditChecklistTitle = false))
                          }, {
                            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                              _createTextVNode(" Annulla ", -1 /* CACHED */)
                            ]))]),
                            _: 1 /* STABLE */
                          })
                        ])
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["data"]))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true),
          (!checklistModello.modello)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(null)))
            : _createCommentVNode("v-if", true)
        ]),
        "matrice-cta": _withCtx(({richiesteDocumenti, isSendChecklist, notaChecklist}) => [
          (!checklistModello.modello)
            ? (_openBlock(), _createBlock(_component_base_button, {
                key: 0,
                mode: "confirm",
                class: "crm:mr-2!",
                state: (richiesteDocumenti && Object.keys(richiesteDocumenti).length < 1) || isSendChecklist ? 'disable' : 'active',
                "onClick:cta": $event => (saveChecklistModel(richiesteDocumenti, notaChecklist))
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode(" Crea modello ", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["state", "onClick:cta"]))
            : _createCommentVNode("v-if", true),
          (checklistModello.modello)
            ? (_openBlock(), _createBlock(_component_base_button, {
                key: 1,
                mode: "confirm",
                class: "crm:mr-2!",
                state: (richiesteDocumenti && Object.keys(richiesteDocumenti).length < 1) || isSendChecklist ? 'disable' : 'active',
                "onClick:cta": $event => (updateModelloChecklist(richiesteDocumenti,notaChecklist, true, checklistModello.modello.modello_id))
              }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode(" Aggiorna modello ", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["state", "onClick:cta"]))
            : _createCommentVNode("v-if", true)
        ]),
        "matrice-body": _withCtx(({richiesteDocumenti, notaChecklist, updateNotaChecklist}) => [
          (_unref(modaleTitoloModello).getShow())
            ? (_openBlock(), _createBlock(_component_base_modal, {
                key: 0,
                title: _unref(modaleTitoloModello).getTitle(),
                id: _unref(modaleTitoloModello).getId(),
                "onModal:closed": _cache[3] || (_cache[3] = $event => (_unref(modaleTitoloModello).close())),
                size: "sm"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_base_icon, {
                      icon: _unref(alert_information_circle),
                      sizing: {width: '15px', height: '15px'},
                      stroke: _unref($DesignSystem).design_colors.info,
                      class: "crm:mt-[5px] crm:mr-2"
                    }, null, 8 /* PROPS */, ["icon", "stroke"]),
                    _cache[9] || (_cache[9] = _createElementVNode("span", { class: "crm:text-info" }, [
                      _createElementVNode("strong", null, "Suggerimento:"),
                      _createTextVNode(" Indicare prima del nome del modello un numero che lo identifichi "),
                      _createElementVNode("br"),
                      _createElementVNode("strong", null, "esempio:"),
                      _createTextVNode(" (40) Costituzione società ")
                    ], -1 /* CACHED */))
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_base_textarea_floating_label, {
                      name: "nota_generale",
                      label: "Istruzioni operative a beneficio del cliente",
                      "onUpdate:validateTo": (params) => updateNotaChecklist(params),
                      validateTo: notaChecklist
                    }, null, 8 /* PROPS */, ["onUpdate:validateTo", "validateTo"])
                  ]),
                  _createVNode(_component_base_form, {
                    name: "form_insert_title_modello_checklist",
                    data: {titoloModello: checklistModello.titoloModello}
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_base_input_text_floating_label, {
                          label: "Inserisci nome del modello",
                          name: "modello_checklist_title",
                          "validate-to": checklistModello.titoloModello,
                          "onUpdate:validateTo": _cache[2] || (_cache[2] = $event => ((checklistModello.titoloModello) = $event))
                        }, null, 8 /* PROPS */, ["validate-to"])
                      ])
                    ]),
                    actions: _withCtx(({formIsValid, formIsComplete}) => [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_base_button, {
                          mode: "confirm",
                          state: formIsComplete ? 'active' : 'disable',
                          "onClick:cta": $event => (saveChecklistModel(richiesteDocumenti, notaChecklist,true)),
                          class: "crm:mt-4!"
                        }, {
                          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                            _createTextVNode(" Crea modello ", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["state", "onClick:cta"])
                      ])
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["data"])
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["title", "id"]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["soggetto-id", "richieste-documenti-default", "force-accordion-actived", "nota-checklist-default"]))
    : _createCommentVNode("v-if", true)
}
}

}